import type { SkillGraphNode } from './getSkillsLevelByUnit';

/**
 * Consolida cada nodo del grafo (`SkillGraphNode`: `id`, `isTarget`, `overallLevel`,
 * `targetSkillImpact`) con su objeto de info completo (`skillInfo`), conservando exactamente
 * el orden y el anidamiento target → nivel → skill de la respuesta.
 *
 * Asume que todo `id` presente en `skillsByLevel` tiene su entrada en `skillInfo`;
 * lanza si no la encuentra para no propagar `undefined` silenciosamente.
 */
export const getSkillsInfoByLevel = <T extends { id: number }>(
  skillsByLevel: SkillGraphNode[][][],
  skillInfo: readonly T[],
): (T & SkillGraphNode)[][][] => {
  const skillInfoById = new Map(skillInfo.map(info => [info.id, info]));

  return skillsByLevel.map(target =>
    target.map(level =>
      level.map(node => {
        const info = skillInfoById.get(node.id);
        if (!info) throw new Error(`No skill info found for skill id ${node.id}`);
        return { ...info, ...node };
      }),
    ),
  );
};
